(function () {
    'use strict';

    /* @ngdoc object
     * @name commons
     * @description
     *
     */
    angular
        .module('commons', [
            'ui.router'
        ]);
}());
